import React from 'react';
import PropTypes from 'prop-types';
var Loader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var loadAnimation = props.loadAnimation,
      loading = props.loading,
      locale = props.locale,
      addPrefix = props.addPrefix,
      renderLoading = props.renderLoading;

  if (!loadAnimation && !loading) {
    return null;
  }

  var loadingElement = /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: addPrefix('loader-wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: addPrefix('loader')
  }, /*#__PURE__*/React.createElement("i", {
    className: addPrefix('loader-icon')
  }), /*#__PURE__*/React.createElement("span", {
    className: addPrefix('loader-text')
  }, locale === null || locale === void 0 ? void 0 : locale.loading)));
  return renderLoading ? renderLoading(loadingElement) : loadingElement;
});
Loader.propTypes = {
  locale: PropTypes.object,
  loadAnimation: PropTypes.bool,
  loading: PropTypes.bool,
  addPrefix: PropTypes.func,
  renderLoading: PropTypes.func
};
Loader.displayName = 'Table.Loader';
export default Loader;